﻿import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { SharedModule } from "../../../components/shared/shared.module";
import { EditRoleComponent } from "../setting/edit-role/edit-role.component";

// ------------------------------------------Start Service----------------------------------------------------------------------//
import { ModalModule } from "ngx-bootstrap";
import { InterceptorService } from "../../../service/components/authentication/interceptor.service";
import { SettingService } from "../../../service/api/jubili/setting.service";
import { EditRoleService } from "../../../service/api/jubili/edit-role.service";
// ------------------------------------------End Service----------------------------------------------------------------------//

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        FormsModule,
        BrowserModule,
        RouterModule,
        SharedModule,
        ModalModule.forRoot()
    ],
    declarations: [
        EditRoleComponent
    ],
    exports: [
        SharedModule,
        EditRoleComponent
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
        SettingService,
        EditRoleService
    ]
})
export class SettingModule { }
